// selectors.ts
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { MerchantState } from '../reducers/auth.reducer';

export const selectMerchantState = createFeatureSelector<MerchantState>('merchant');

export const selectMerchantDetails = createSelector(
  selectMerchantState,
  (state: MerchantState) => state.merchant
);

export const selectMerchantError = createSelector(
  selectMerchantState,
  (state: MerchantState) => state.error
);

export const selectReserveFund = createSelector(
  selectMerchantState,
  (state: MerchantState) => state.reserveFund
);

export const selectMerchantKeyValidation = createSelector(
  selectMerchantState,
  (state: MerchantState) => state.merchantKeyValidation
);

export const selectQRlink = createSelector(
  selectMerchantState,
  (state: MerchantState) => state.QRlink
);

export const selectPermissions = createSelector(
  selectMerchantState,
  (state: MerchantState) => state.permissions
);
export const selectTransactionDetailsCount = createSelector(
  selectMerchantState,
  (state: MerchantState) => state.transactionDetailsCount
);
export const selectEsignProcessStatus = createSelector(
  selectMerchantState,
  (state: MerchantState) => state.esignProcessStatus
);
export const selectPaymentLink = createSelector(
  selectMerchantState,
  (state: MerchantState) => state.paymentLink
);
export const selectLatestMerchantSalesContact = createSelector(
  selectMerchantState,
  (state: MerchantState) => state.latestMerchantSalesContact
);